{
    "ai_modal_title_1": "Verbessern Sie Ihren Text mit der KI",
    "ai_modal_title_2": "Neuen Text mit Hilfe der KI erstellen",
    "ai_description": "Benutzen Sie die KI-Inhaltsgenerierung um Ihre Texte zu verbessern.",
    "ai_learn_more": "Erfahren Sie mehr",
    "ai_copy_text": "Text kopieren",
    "ai_describe_your_text": "Beschreiben Sie Ihren Text",
    "ai_describe_your_text_example": "Beispiel: Eine kurze Beschreibung für einen Online-Shop, der handgefertigte Seife verkauft",
    "ai_new_request": "Neue Anfrage erstellen",
    "ai_create_text": "Text generieren",
    "ai_apply_text": "Text anwenden",
    "ai_try_one_more": "Erneut versuchen",
    "ai_correct_errors": "Fehler korrigieren",
    "ai_make_longer": "Erweitern",
    "ai_make_shorter": "Abkürzen",
    "ai_simplify": "Vereinfachen",
    "ai_business_tone": "Formal",
    "ai_ceremonial_tone": "Festlich",
    "ai_fun_tone": "Joyful",
    "ai_friendly_tone": "Freundlich",
    "ai_change_tone": "Ton der Stimme ändern",
    "ai_improve_text": "Text verbessern",
    "ai_words_number": "Anzahl der Worte:",
    "ai_translate": "Übersetzen",
    "ai_translate_to_ru": "Auf Russisch übersetzen",
    "ai_translate_to_en": "Auf Englisch übersetzen",
    "ai_add_creativity": "Kreativität hinzufügen",
    "ai_text_too_large": "Ihr Text ist zu lang, um KI zu verwenden. Kürzen Sie ihn oder erstellen Sie mit Hilfe von KI einen neuen Text zum gewünschten Thema.",
    "ai_translate_to_ua": "Auf Ukrainisch übersetzen",
    "ai_translate_to_es": "Auf Spanisch übersetzen",
    "ai_translate_to_pt": "Auf Portugiesisch übersetzen",
    "ai_translate_to_tr": "Auf Türkisch übersetzen",
    "ai_translate_to_fr": "Auf Französisch übersetzen",
    "ai_translate_to_de": "Auf Deutsch übersetzen",
    "ai_translate_to_it": "Auf Italienisch übersetzen",
    "ai_translate_to_pl": "Auf Polnisch übersetzen",
    "ai_free_request_error": "Gratis Anfragen sind beendet",
    "ai_free_request_number": "Anfrage Nummer: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "Sie können bis zu 200 kostenlose KI-Tool-Anfragen verwenden. Um weitere Anfragen zu stellen, aktivieren Sie in Ihren Kontoeinstellungen Ihre API-Schlüssel an den AI-Anbieter.",
    "cancel": "Abbrechen",
    "gpt_error_quota": "Sie haben Ihr Limit für API-Anfragen erreicht. Um die KI-Tools weiterhin zu nutzen, überprüfen Sie Ihr aktuelles Limit oder laden Sie Ihr Guthaben in den OpenAI-Kontoeinstellungen auf.",
    "ai_generated_disclaimer": "Sie sind für den generierten Text verantwortlich. Prüfen Sie ihn vor der Veröffentlichung."
}
